import IconContainer from '@/components/IconContainer'

export default function IconEyeOff(props) {
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="Eye Off Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M0.734545 2.09816L1.76 1.06543L14.6545 13.9745L13.6291 15L11.1345 12.5054C10.16 12.8836 9.10545 13.1018 8 13.1018C4.36364 13.1018 1.25818 10.84 0 7.64725C0.56 6.21452 1.49818 4.97816 2.68364 4.04725L0.734545 2.09816ZM11.6364 7.64725C11.6364 5.63998 10.0073 4.01089 7.99999 4.01089C7.62908 4.01089 7.27272 4.08361 6.9309 4.18543L5.35272 2.60725C6.18908 2.33816 7.07635 2.1927 7.99999 2.1927C11.6364 2.1927 14.7418 4.45452 16 7.63998C15.4982 8.91998 14.6982 10.04 13.6873 10.9345L11.4618 8.70907C11.5636 8.37452 11.6364 8.01816 11.6364 7.64725ZM7.99964 11.2837C5.99237 11.2837 4.36328 9.65458 4.36328 7.64731C4.36328 7.08731 4.49419 6.5564 4.71965 6.09094L5.86146 7.23276C5.83964 7.36367 5.81783 7.50185 5.81783 7.64731C5.81783 8.85458 6.79237 9.82912 7.99964 9.82912C8.1451 9.82912 8.27601 9.80731 8.41419 9.77822L9.55601 10.92C9.08328 11.1528 8.55964 11.2837 7.99964 11.2837ZM10.1602 7.4073C10.0511 6.38912 9.25114 5.5964 8.24023 5.4873L10.1602 7.4073Z" />
    </IconContainer>
  )
}
